const LISTAR_DADOS = (state, payload) => {
  state.items = payload.data || []
  state.paginacao = {
    per_page: payload.per_page || 20,
    current_page: payload.current_page || 1,
    last_page: payload.last_page || 1,
    total: payload.total || 0,
    from: payload.from || 1,
    to: payload.to || 0
  }
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const CARREGANDO_CONFIGURACAO = (state, payload) => {
  state.carregandoConfiguracao = payload
}

const DEFINIR_CONFIGURACAO_INTEGRACAO = (state, payload) => {
  state.configuracaoIntegracao = payload
}

const CARREGANDO_DASHBOARD = (state, payload) => {
  state.carregandoDashboard = payload
}

const DEFINIR_DASHBOARD_CENTRO_FUNCIONAL = (state, payload) => {
  const provedores = payload?.provedores || {}
  const lista = Array.isArray(provedores) ? provedores : (provedores.data || [])

  state.dashboardCentroFuncional = {
    provedores: lista,
    totais: payload?.totais || { telmex: 0, claro_geral: 0, total: 0 }
  }

  state.paginacaoDashboard = {
    per_page: provedores.per_page || state.paginacaoDashboard.per_page,
    current_page: provedores.current_page || 1,
    last_page: provedores.last_page || 1,
    total: provedores.total ?? lista.length,
    from: provedores.from || 0,
    to: provedores.to || 0
  }
}

export {
  LISTAR_DADOS,
  CARREGANDO,
  CARREGANDO_CONFIGURACAO,
  DEFINIR_CONFIGURACAO_INTEGRACAO,
  CARREGANDO_DASHBOARD,
  DEFINIR_DASHBOARD_CENTRO_FUNCIONAL
}